import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getArea = (areaId: number | undefined): Promise<IGetArea> => {
  return axiosDefaultApi.get(`/api/Areas/GetAreaViaID/${areaId}`);
};

type QueryFnType = typeof getArea;

type UseGetAreaOptions = {
  areaId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetArea = ({ areaId , config }: UseGetAreaOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getArea_${areaId}`],
    queryFn: () => getArea(areaId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Περιοχής.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};